import {
  React,
  createContext,
  useContext,
} from 'react';
import api from 'src/services/api';
import { SiteContext } from './SiteContext';

export const OrderImageServiceContext = createContext();

const OrderImageServiceProvider = (prop) => {
  const baseUrl = 'user/orderImage';
  const { children } = prop;
  const {
    notifyMessage,
    setNotifyMessage,
    loading,
    setLoading
  } = useContext(SiteContext);

  const closeNotifyMessage = () => {
    setNotifyMessage({
      ...notifyMessage,
      open: false
    });
  };

  const notifyMessageSave = (action) => {
    setNotifyMessage({
      text: `Registro ${action} com Sucesso !`,
      type: 'success',
      open: true
    });
  };

  const notifyMessageError = (action, err) => {
    setNotifyMessage({
      text: `Erro ao ${action} =( ${err}`,
      type: 'error',
      open: true
    });
  };

  const deleteOrderImage = async (id) => {
    setLoading(true);
    const response = await api.delete(`${baseUrl}/${id}`)
      .then(() => {
        setLoading(false);
        notifyMessageSave('excluido');
        return true;
      })
      .catch((err) => {
        setLoading(false);
        notifyMessageError('Excluir', err);
        return false;
      });
    return response;
  };

  return (
    <OrderImageServiceContext.Provider
      value={{
        loading,
        deleteOrderImage,
        setNotifyMessage,
        closeNotifyMessage,
        notifyMessageError,
        notifyMessageSave
      }}
    >
      { children }
    </OrderImageServiceContext.Provider>

  );
};

export default OrderImageServiceProvider;
